module.exports = __webpack_public_path__ + "img/xiaochxu.cdea84ad.png";